export default __webpack_public_path__ + "src/assets/icn-offline.c1f82d7d5650f68eb7d8ac2509347817.svg";